import type { FC } from 'react';
import { Button, Flex, Icon, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { DISCORD_LINK } from '@/constants/constants';

export const NoDiscordStub: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Icon.LockOpen size={72} color="iconMain" />
            <Flex vertical align="center" gap={16}>
                <Typography.Heading level={2}>{t('Apply_NoDiscord_Stub_Title')}</Typography.Heading>
                <Typography.Paragraph level={1}>{t('Apply_NoDiscord_Stub_Description')}</Typography.Paragraph>
            </Flex>
            <Button href={DISCORD_LINK} size="m">
                {t('Apply_NoDiscord_Stub_Button')}
            </Button>
        </>
    );
};
